import { CONTEXT_ROLES } from '@/scenes/Event/utils/constants';

export function getIsModuleLiveEnable(contextRole, moduleLive) {
  switch (contextRole) {
    case CONTEXT_ROLES.CANDIDATE: return moduleLive?.participantEnable;
    case CONTEXT_ROLES.RECRUITER: return moduleLive?.recruiterEnable;
    case CONTEXT_ROLES.OWNER: return moduleLive?.adminEnable;
    default: return moduleLive?.enable;
  }
}